var map = {
	"./_module.ts": 884,
	"./components/student-attendance-logs/student-attendance-logs.component.ts": 885,
	"./components/support-attendance-logs/support-attendance-logs.component.ts": 886,
	"./components/support-details/support-details.component.ts": 628,
	"./components/support-details/support-details.controller.ts": 629,
	"./support-overview.controller.ts": 438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1769;